class Header extends Component {
	constructor(el) {
		super(el);
		this.navOpener = this.$find('[data-nav-opener]');
		this.headerOffset = this.$el.offsetTop - window.scrollY;
		this.lastScroll = 0;
		this.addEventListeners();
		if (window.pageYOffset > 0) {
			this.$el.classList.add('is-sticked');
		}
	}

	hidingOnScroll() {
		const currentScroll = window.pageYOffset;

		if(currentScroll > 0) {
			this.$el.classList.add('is-sticked');
			this.$el.classList[currentScroll > this.lastScroll ? 'add' : 'remove']('is-up');
		}
		else{
			this.$el.classList.remove('is-up');
			this.$el.classList.remove('is-sticked');
		}

		this.lastScroll = currentScroll;
	}

	addEventListeners() {
		this.navOpener.addEventListener('click', e => {
			e.stopPropagation();
			EventBus.getInstance().dispatchEvent('mainNavigationOpen');
		});
		window.addEventListener('scroll', () => this.hidingOnScroll(), {passive: true});
	}
}